module.exports = __webpack_public_path__ + "img/intro_2.10b628f.png";